import React, { Component } from 'react';

class EditIngreso extends Component {
    state = {  }
    render() { 
        return (
            <div>Editar Ingreso</div>
        );
    }
}
 
export default EditIngreso;


// WEBPACK FOOTER //
// ./src/views/WebMaster/EditIngreso.jsx